import styled from "styled-components";
import { Heading5Regular } from "../../../../../common/Typography/Heading5";
import { Paragraph16Regular } from "../../../../../common/Typography/Paragraph16";

const Container = styled.div``;

const Title = styled(Heading5Regular)`
  padding-top: 40px;
  text-align: center;
  padding-bottom: 5px;
`;

const Description = styled(Paragraph16Regular)`
  color: ${({ theme }) => theme.primaryColor};
  opacity: 0.7;
  text-align: center;
`;

interface ISignupTitleMobileProps {
  title: string;
  description: string;
}

const SignupTitleMobile = ({ title, description }: ISignupTitleMobileProps) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  );
};

export default SignupTitleMobile;
